import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TrackerWidgetsComponent } from './tracker-widgets/tracker-widgets.component';
import { WindowRef } from './window.service';
import { TrackerWidgetV2Component } from './tracker-widget-v2/tracker-widget-v2.component';

@NgModule({
  declarations: [
    AppComponent,
    TrackerWidgetsComponent,
    TrackerWidgetV2Component
  ],
  imports: [
    AppRoutingModule,
    BrowserModule
  ],
  providers: [
    WindowRef
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
